'use client';
import { useEffect } from 'react';
import { User } from '@/types/User';
import { initializeDatadogRUM } from '@/util/datadog';
import { useCookieConsent } from '@/components/hook/cookie-consent';

type DatadogInitProps = {
  user?: User;
};

/**
 * Component created with the help of this guide
 * https://docs.datadoghq.com/real_user_monitoring/guide/monitor-your-nextjs-app-with-rum/?tab=npm
 */
function DatadogInit(props: DatadogInitProps) {
  const { user } = props;
  const consent = useCookieConsent();

  useEffect(() => {
    // Only initialize if user is logged in and analytics consent is given
    if (user && consent.analytics) {
      initializeDatadogRUM();
    }
  }, [user, consent.analytics]);

  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}

export default DatadogInit;
